<template>
    <div>
        <v-container class="pr-0 pl-0 pt-2 pb-2 row_item" v-for="(detail,index) in details" :key=detail.id>
            <v-row align="center">
                <v-col cols=3 xl=2 offset-xl=1 class="text-left pt-0 pb-0">
                    <v-row class="pt-0 pb-0">
                        <v-col cols="12" class="pt-0 pb-0">
                            <div class="text-subtitle-1">
                                <span class="font-weight-regular">
                                    Proposal: 
                                </span>
                                <span class="font-weight-light">
                                    {{detail.rk_name}}    
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols=2 class="text-center pt-0 pb-0">
                    <v-row class="pt-0 pb-0">
                        <v-col cols="12" class="pt-0 pb-0 pr-0 pl-0">
                            <div class="text-subtitle-1">
                                <span class="font-weight-regular">
                                    Advisor: 
                                </span>
                                <span class="font-weight-light">
                                    {{detail.advisor_name}}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols=3 xl=2 class="text-center pt-0 pb-0 pr-0 pb-0">
                    <ProposalQueue :detail=detail :id=detail.proposal_id :status=detail.proposal_pdf />
                     <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab 
                            small
                            color="grey lighten-5"
                            class="mx-2"
                            v-on="on"
                            elevation=0
                          >
                            <v-icon color="amber darken-2" large>mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit Proposal<span> <v-icon color="amber darken-2">mdi-alert-circle-outline</v-icon>Coming Soon!</span></span>
                    </v-tooltip>
                    <v-dialog
                    v-model="confirmProposal[index]"
                    :retain-focus="false"
                    persistent
                    max-width="290px"
                    >
                        <template v-slot:activator="{ on: confirm, attrs }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on: tooltip }">
                                  <v-btn
                                    fab 
                                    small
                                    color="grey lighten-5"
                                    class="mx-2"
                                    elevation=0
                                    v-bind="attrs"
                                    v-on="{ ...tooltip, ...confirm }"
                                  >
                                    <v-icon color="red" large>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete Proposal</span>
                            </v-tooltip>
                        </template>
                        <v-card>
                            <v-card-title><span class='ml-12'>Confirm Delete</span></v-card-title>
                            <v-card-text>
                                Are you sure? This can not be undone.
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                color="primary"
                                @click="deleteProposal(detail, index)"
                                >
                                    Confirm
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                depressed
                                @click="confirmProposal[index] = false">
                                    Cancel
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!--
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab 
                            small
                            color="grey lighten-5"
                            class="mx-2"
                            v-on="on"
                            elevation=0
                            @click="deleteProposal(detail.proposal_id)"
                          >
                            <v-icon color="red" large>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete Proposal</span>
                    </v-tooltip>
                    -->
                </v-col>
                <v-col cols=4 xl=4 offset-xl=1 class="text-center pt-0 pb-0 ">
                    <v-row class="pt-0 pb-0">
                        <v-col cols="12" class="pt-0 pb-0">
                            <ProposalListAA :detail=detail :defaultAgreement=defaultAgreement :object=object />
                        </v-col>
                    </v-row>
                </v-col>
                
            </v-row>
        </v-container>
    </div>
</template>

<script>
  import ProposalListAA from '@/components/proposalcomps/ProposalListAA.vue';
  import ProposalQueue from '@/components/proposalcomps/ProposalQueue.vue';
  import {mapActions, mapGetters} from 'vuex';
  export default {
    
    data: () => ({
       confirmProposal: {},
       proposal_status: '', 
    }),  
      
    props: {
        details: [Array, Object],
        object: [Object]
    },
    
    mounted () {
        console.log(this.object);
        this.mapProps();
    },
    
    computed: {
      ...mapGetters({
        globalContext: 'globalContext'
      }),
      
      defaultAgreement() {
            let templates = this.globalContext.templatesContext
            let duration = this.object.duration 
            
            let defaultObj = templates.filter(function(template){
                return template.property.duration == duration;
            });
            return defaultObj[0].agreement.default;
        },
    },
    watch: {
        proposal_status: (old_value, new_value) => {
            if(new_value !== "complete"){
                this.createInterval
            } else {
                this.clearInterval
            }
        }
    },
    methods: {
        ...mapActions(['deleteProposalFromList','downloadProposalDOCX']),
        mapProps() {
            console.log(this.details[0]);
        },
        editProposal(item){
            this.$emit('edit', item);
            console.log('Edit Proposal ID: '+item.proposal_id);
        },
        
        downloadPropPDF(item){
            this.downloadProposalPDF(item);
            console.log('Download PDF Proposal ID: ' + item.proposal_id);
        },
        
        downloadDOCX(){
            this.downloadProposalDOCX();
            console.log('Download Template');
        },
        
        deleteProposal(item, index){
            this.deleteProposalFromList(item.proposal_id);
            this.confirmProposal[index] = false;
        },
        
    },
    components: {
        ProposalListAA, ProposalQueue
    }
  };
</script>

<style type="text/css" scoped>
    .border {
      border-style: solid !important;
    }
    .v-data-table__expanded__content{
        box-shadow: none;
    }
    .row_item {
        border-bottom: thin solid rgb(0,0,0,30%);
    }
</style>